import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    label: {
      editableTabsValue: "",
      editableTabs: [],
      tabIndex: 0,
      title: "",
      monery: "", // 账户余额
      username: "", //公司名称
      ip: "",
    },
    checktabs: [],
    admin_cate_id: "",
    client: "1",
    xufei: "",
  },
  mutations: {
    detabs(state, dename) {
      if (state.checktabs.indexOf(dename) > -1) {
        state.checktabs.splice(state.checktabs.indexOf(dename), 1);
      }
    },
    deOtherTabs(state, dename) {
      state.checktabs = [dename];
    },
    clearChecktabs(state) {
      state.checktabs = [];
    },
  },
  actions: {},
  modules: {},
});
